import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ProofOfDelivery, PodType } from '@evermile/customer-tracking';
import { ProofOfDelivery as ProofOfDeliveryGeneral } from '@evermile/api';
import { GtmTracking } from '../../../services/gtm.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { OverlayPanel } from 'primeng/overlaypanel/overlaypanel';
@Component({
  selector: 'common-delivery-pod',
  templateUrl: './delivery-pod.component.html',
  styleUrls: ['./delivery-pod.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate(100)]),
      transition(':leave', [animate(100)]),
    ]),
  ],
})
export class DeliveryPodComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('imagePreviewOp') imagePreviewOp?: OverlayPanel;
  @Input() notes: string[] = [];
  @Input() proofOfDelivery: ProofOfDelivery[] | ProofOfDeliveryGeneral[] = [];
  @Input() brandColor!: string;
  @Input() orderStatus?: string;
  @Input() contained?: boolean;
  @Input() singleOrderView?: boolean;
  @Input() isExternalPickup?: boolean;
  imageForPreview = '';
  isMobileMode = false;

  urlLoadedMap: Map<string, boolean> = new Map<string, boolean>();

  readonly TypeEnum = PodType;
  panelAnimationDisabled = true;

  //Subs
  subMobileMode?: Subscription;

  constructor(
    private gtmTracking: GtmTracking,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit() {
    this.proofOfDelivery.sort((a, b) => {
      return a.type === PodType.Photo ? -1 : 1;
    });
    for (const pod of this.proofOfDelivery) {
      if (pod.urls) {
        for (const url of pod.urls) {
          this.urlLoadedMap.set(url, false);
        }
      }
    }
    // This is due to a bug causing the panel to open when inside an animated container
    setTimeout(() => {
      this.panelAnimationDisabled = false;
    }, 200);
    this.setMobileMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['notes']) {
      this.notes = this.notes?.filter((note) => !!note?.trim());
    }
  }

  ngOnDestroy() {
    if (this.subMobileMode) this.subMobileMode.unsubscribe();
  }

  setMobileMode() {
    this.subMobileMode = this.breakpointObserver.observe(['(max-width: 1024px)']).subscribe((result) => {
      this.isMobileMode = result.matches;
    });
  }

  isUrlLoaded(url: string): boolean {
    return this.urlLoadedMap.get(url) || false;
  }

  setUrlLoaded(url: string) {
    this.urlLoadedMap.set(url, true);
  }

  handleMissingImage(event: ErrorEvent, missingUrl: string) {
    const imgElement = event.target as HTMLImageElement;
    const parent = imgElement.parentElement;
    if (parent) parent.style.display = 'none';
    this.setUrlLoaded(missingUrl);
  }

  trackPhotosPanel(expanded: boolean) {
    this.gtmTracking.clickEvent(
      `Tracking Page/${this.orderStatus}/Proof of delivery ${expanded ? 'opened' : 'closed'}`,
    );
  }

  openImagePreview(url: string, bgWhite = false, event: any) {
    this.imageForPreview = url;
    this.imagePreviewOp?.show(event);
  }

  @HostListener('window:keydown.esc', ['$event.target'])
  closePodPreview(event: any) {
    this.imagePreviewOp?.hide();
  }
}
